// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/TopBar/TopBar.css */

.top-bar {
  flex-shrink: 0;
  height: 60px;
  width: 100%;
  background-color: transparent;
  color: var(--text-primary);
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 var(--layout-outer);
  position: relative;
  z-index: 1000;
  box-sizing: border-box;
}

.topbar-logo {
  display: block;
  color: var(--accent);
}

.top-bar-inner {
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  max-width: var(--layout-content-max, 1120px);
  height: 100%;
}

/* Homepage greeting: true center column so it never sits under the avatar row */
.top-bar-greeting {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  pointer-events: none;
  text-align: center;
  white-space: nowrap;
  z-index: 1;
}

.top-bar-greeting-message {
  margin: 0;
  color: var(--text-primary);
}

.top-bar-greeting-date {
  margin: 0;
  color: var(--text-tertiary);
  font-size: 11px;
  letter-spacing: 0.02em;
}

/* Narrow screens keep the greeting but drop the date line */
@media (max-width: 1023px) {
  .top-bar-greeting-date {
    display: none;
  }
}

/* Below this the logo and avatar leave no safe gap in the middle */
@media (max-width: 359px) {
  .top-bar-greeting {
    display: none;
  }
}

.top-bar-logo {
  display: flex;
  align-items: center;   /* Center logo vertically */
  margin-right: 20px;   /* Space between logo and other elements */
}

.top-bar-left {
  grid-column: 1;
  justify-self: start;
  display: flex;
  align-items: center;   /* Center items vertically */
  gap: 16px;
  min-width: 0;
}

.top-bar-nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.top-bar-nav-link {
  appearance: none;
  border: none;
  background: transparent;
  color: var(--color-dark-gray);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.top-bar-nav-link:hover {
  background: var(--accent-softer);
  color: var(--accent);
}

@media (max-width: 768px) {
  .top-bar-nav {
    display: none;
  }
}
  
.top-bar-right {
  grid-column: 3;
  justify-self: end;
  display: flex;
  align-items: center;
}
  
/* Style for authentication buttons container */
.auth-buttons {
  display: flex;
  gap: 0px;
  align-items: center;
}

.user-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-badge {
  background-color: var(--accent);
  color: var(--text-on-accent);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-avatar-clickable {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.user-avatar-clickable:hover {
  background-color: var(--accent-dim);
}

.user-avatar-clickable:active {
  background-color: var(--accent-dim);
}

.user-badge p {
  margin: 0;
  color: var(--text-on-accent);
}

/* Mobile auth section - hidden by default on desktop */
.mobile-auth {
  display: none;
}

.mobile-auth-buttons {
  display: none;
  gap: 8px;
  align-items: center;
}

.mobile-user-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-user-badge {
  background-color: var(--accent);
  color: var(--text-on-accent);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.mobile-user-badge:hover {
  background-color: var(--accent-dim);
}

.mobile-user-badge:active {
  background-color: var(--accent-dim);
}

.mobile-logout-btn {
  padding: 4px 8px !important;
  font-size: 12px !important;
  min-width: auto !important;
}

.mobile-login-btn {
  padding: 4px 8px !important;
  font-size: 12px !important;
  min-width: auto !important;
}

.mobile-signup-btn {
  padding: 4px 8px !important;
  font-size: 12px !important;
  min-width: auto !important;
}

/* Mobile menu container - hidden by default */
.mobile-menu-container {
  display: none;
}

/* Mobile-specific topbar styling */
@media (max-width: 768px) {
  .top-bar {
    padding: 0 16px;
    height: 56px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: color-mix(in srgb, var(--bg-base) 78%, transparent);
    backdrop-filter: blur(16px);
    border-bottom: 1px solid var(--border-subtle);
    box-shadow: none;
  }

  .top-bar-inner {
    max-width: none;
    grid-template-columns: auto 1fr auto;
  }
  
  .top-bar-left {
    grid-column: 1;
  }

  .top-bar-greeting {
    grid-column: 2;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .top-bar-greeting-message {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  
  .top-bar-right {
    grid-column: 3;
    justify-self: end;
    gap: 12px;
  }
  
  /* Hide desktop auth buttons on mobile */
  .auth-buttons {
    display: none !important;
  }
  
  .user-section {
    display: none !important;
  }
  
  /* Show mobile auth section on mobile */
  .mobile-auth {
    display: flex !important;
    align-items: center;
  }
  
  .mobile-auth-buttons {
    display: flex !important;
  }
  
  /* Show mobile menu container on mobile */
  .mobile-menu-container {
    display: flex !important;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Topbar/Topbar.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,4CAA4C;EAC5C,YAAY;AACd;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE;IACE,aAAa;EACf;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB,IAAI,2BAA2B;EAClD,kBAAkB,IAAI,0CAA0C;AAClE;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB,IAAI,4BAA4B;EACnD,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,qEAAqE;IACrE,2BAA2B;IAC3B,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,SAAS;EACX;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,uCAAuC;EACvC;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF","sourcesContent":["/* src/components/TopBar/TopBar.css */\n\n.top-bar {\n  flex-shrink: 0;\n  height: 60px;\n  width: 100%;\n  background-color: transparent;\n  color: var(--text-primary);\n  border-bottom: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 var(--layout-outer);\n  position: relative;\n  z-index: 1000;\n  box-sizing: border-box;\n}\n\n.topbar-logo {\n  display: block;\n  color: var(--accent);\n}\n\n.top-bar-inner {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  width: 100%;\n  max-width: var(--layout-content-max, 1120px);\n  height: 100%;\n}\n\n/* Homepage greeting: true center column so it never sits under the avatar row */\n.top-bar-greeting {\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n  pointer-events: none;\n  text-align: center;\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.top-bar-greeting-message {\n  margin: 0;\n  color: var(--text-primary);\n}\n\n.top-bar-greeting-date {\n  margin: 0;\n  color: var(--text-tertiary);\n  font-size: 11px;\n  letter-spacing: 0.02em;\n}\n\n/* Narrow screens keep the greeting but drop the date line */\n@media (max-width: 1023px) {\n  .top-bar-greeting-date {\n    display: none;\n  }\n}\n\n/* Below this the logo and avatar leave no safe gap in the middle */\n@media (max-width: 359px) {\n  .top-bar-greeting {\n    display: none;\n  }\n}\n\n.top-bar-logo {\n  display: flex;\n  align-items: center;   /* Center logo vertically */\n  margin-right: 20px;   /* Space between logo and other elements */\n}\n\n.top-bar-left {\n  grid-column: 1;\n  justify-self: start;\n  display: flex;\n  align-items: center;   /* Center items vertically */\n  gap: 16px;\n  min-width: 0;\n}\n\n.top-bar-nav {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.top-bar-nav-link {\n  appearance: none;\n  border: none;\n  background: transparent;\n  color: var(--color-dark-gray);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px 12px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.top-bar-nav-link:hover {\n  background: var(--accent-softer);\n  color: var(--accent);\n}\n\n@media (max-width: 768px) {\n  .top-bar-nav {\n    display: none;\n  }\n}\n  \n.top-bar-right {\n  grid-column: 3;\n  justify-self: end;\n  display: flex;\n  align-items: center;\n}\n  \n/* Style for authentication buttons container */\n.auth-buttons {\n  display: flex;\n  gap: 0px;\n  align-items: center;\n}\n\n.user-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-badge {\n  background-color: var(--accent);\n  color: var(--text-on-accent);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user-avatar-clickable {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.user-avatar-clickable:hover {\n  background-color: var(--accent-dim);\n}\n\n.user-avatar-clickable:active {\n  background-color: var(--accent-dim);\n}\n\n.user-badge p {\n  margin: 0;\n  color: var(--text-on-accent);\n}\n\n/* Mobile auth section - hidden by default on desktop */\n.mobile-auth {\n  display: none;\n}\n\n.mobile-auth-buttons {\n  display: none;\n  gap: 8px;\n  align-items: center;\n}\n\n.mobile-user-section {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mobile-user-badge {\n  background-color: var(--accent);\n  color: var(--text-on-accent);\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.mobile-user-badge:hover {\n  background-color: var(--accent-dim);\n}\n\n.mobile-user-badge:active {\n  background-color: var(--accent-dim);\n}\n\n.mobile-logout-btn {\n  padding: 4px 8px !important;\n  font-size: 12px !important;\n  min-width: auto !important;\n}\n\n.mobile-login-btn {\n  padding: 4px 8px !important;\n  font-size: 12px !important;\n  min-width: auto !important;\n}\n\n.mobile-signup-btn {\n  padding: 4px 8px !important;\n  font-size: 12px !important;\n  min-width: auto !important;\n}\n\n/* Mobile menu container - hidden by default */\n.mobile-menu-container {\n  display: none;\n}\n\n/* Mobile-specific topbar styling */\n@media (max-width: 768px) {\n  .top-bar {\n    padding: 0 16px;\n    height: 56px;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background-color: color-mix(in srgb, var(--bg-base) 78%, transparent);\n    backdrop-filter: blur(16px);\n    border-bottom: 1px solid var(--border-subtle);\n    box-shadow: none;\n  }\n\n  .top-bar-inner {\n    max-width: none;\n    grid-template-columns: auto 1fr auto;\n  }\n  \n  .top-bar-left {\n    grid-column: 1;\n  }\n\n  .top-bar-greeting {\n    grid-column: 2;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .top-bar-greeting-message {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n  }\n  \n  .top-bar-right {\n    grid-column: 3;\n    justify-self: end;\n    gap: 12px;\n  }\n  \n  /* Hide desktop auth buttons on mobile */\n  .auth-buttons {\n    display: none !important;\n  }\n  \n  .user-section {\n    display: none !important;\n  }\n  \n  /* Show mobile auth section on mobile */\n  .mobile-auth {\n    display: flex !important;\n    align-items: center;\n  }\n  \n  .mobile-auth-buttons {\n    display: flex !important;\n  }\n  \n  /* Show mobile menu container on mobile */\n  .mobile-menu-container {\n    display: flex !important;\n    align-items: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
